<template>
  <section v-if="hasContent" class="lead-flow-overview-section">
    <h3>Trip details</h3>
    <div v-if="requestText" class="lead-flow-trip-details__request">
      <span>Request</span>
      <p
        :class="{ 'lead-flow-trip-details__request-text--collapsed': collapsible && !expanded }"
      >
        {{ requestText }}
      </p>
      <button
        v-if="collapsible"
        type="button"
        @click="expanded = !expanded"
      >
        {{ expanded ? 'Show less' : 'Show more' }}
      </button>
    </div>
    <dl v-if="sourceName || urlValue">
      <div v-if="sourceName">
        <dt>Source</dt>
        <dd :title="sourceName">{{ sourceName }}</dd>
      </div>
      <div v-if="urlValue">
        <dt>URL</dt>
        <dd :title="urlValue">
          <a :href="urlValue" target="_blank" rel="noopener noreferrer">{{ urlValue }}</a>
        </dd>
      </div>
    </dl>
  </section>
</template>

<script>
export default {
  name: 'LeadTripDetails',
  props: {
    request: {
      type: String,
      default: ''
    },
    source: {
      type: Object,
      default: null
    },
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      expanded: false
    }
  },
  watch: {
    request() {
      this.expanded = false
    }
  },
  computed: {
    requestText() {
      return this.request.trim()
    },
    collapsible() {
      return this.requestText.length > 280 || this.requestText.split(/\r?\n/).length > 5
    },
    sourceName() {
      return this.source && this.source.name ? this.source.name : ''
    },
    urlValue() {
      return this.url.trim()
    },
    hasContent() {
      return Boolean(this.requestText || this.sourceName || this.urlValue)
    }
  }
}
</script>

<style scoped>
.lead-flow-trip-details__request {
  margin-bottom: 13px;
}

.lead-flow-trip-details__request > span {
  color: #7f8c8b;
  font-size: 16px !important;
  font-weight: 600;
}

.lead-flow-trip-details__request p {
  overflow-wrap: anywhere;
  margin: 6px 0 0;
  color: #344749;
  font-size: 12px;
  line-height: 18px;
  white-space: pre-line;
}

.lead-flow-trip-details__request-text--collapsed {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}

.lead-flow-trip-details__request button {
  margin-top: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #4f7e1d;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}
</style>
